import { render } from "./PR32-07262023.vue?vue&type=template&id=5dfd0bf1"
import script from "./PR32-07262023.vue?vue&type=script&lang=js"
export * from "./PR32-07262023.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__